export default {"src":"/_next/static/media/moonriver-icon-new.f15e1261.svg","height":395,"width":395,"blurWidth":0,"blurHeight":0};